import React from 'react';
import { Breadcrumb, BreadcrumbItem, Button } from 'carbon-components-react';
import Add16 from "@carbon/icons-react/lib/add/16";
import { useHistory } from 'react-router-dom';
import i18n from "../../i18n";


require("./_create-automata.scss");

const RunAutomataPage = props => {

    const history = useHistory();

    const title = i18n.t('createAutomata.title');
    const createNewRequest = i18n.t('createAutomata.createNewRequest');
    const home = i18n.t('qualityCode.Home');


    return (
        <div className="create-automata-container">
            <div className="create-automata-header">
                <div>
                    <Breadcrumb aria-label="Page navigation">
                        <BreadcrumbItem href='/'>
                            {home}
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <div className="title">
                        {title}
                    </div>
                </div>
                <div>
                    <Button renderIcon={Add16} onClick={() => history.push('/automata/createAutomata')}>{createNewRequest}</Button>
                </div>
            </div>

        </div>
    );
};
export default RunAutomataPage;
